import { supabase } from '@/lib/supabase'

export type OverlayKeys = 'ema12'|'ema26'|'ema200'|'fibo'
export type OverlaysForMembers = { ema12: boolean; ema26: boolean; ema200: boolean; fibo: boolean }

const KEYS: Record<OverlayKeys, string> = {
  ema12: 'chart.overlays.ema12.member_visible',
  ema26: 'chart.overlays.ema26.member_visible',
  ema200: 'chart.overlays.ema200.member_visible',
  fibo: 'chart.overlays.fibo.member_visible',
}

export async function getOverlaysForMembers(): Promise<OverlaysForMembers> {
  const keys = Object.values(KEYS)
  const { data, error } = await supabase
    .from('app_settings')
    .select('key,value')
    .in('key', keys)

  if (error) throw error
  const map = new Map<string, string>()
  for (const r of (data || [])) map.set(String((r as any).key), String((r as any).value ?? 'false'))
  return {
    ema12: (map.get(KEYS.ema12) ?? 'false') === 'true',
    ema26: (map.get(KEYS.ema26) ?? 'false') === 'true',
    ema200: (map.get(KEYS.ema200) ?? 'false') === 'true',
    fibo: (map.get(KEYS.fibo) ?? 'false') === 'true',
  }
}

export async function setOverlayMemberVisible(key: OverlayKeys, on: boolean): Promise<void> {
  const { error } = await supabase
    .from('app_settings')
    .upsert({ key: KEYS[key], value: on ? 'true' : 'false' }, { onConflict: 'key' })
  if (error) throw error
}

export async function setOverlaysForMembers(values: Partial<OverlaysForMembers>): Promise<void> {
  const rows: Array<{ key: string; value: string }> = []
  for (const k of Object.keys(values) as OverlayKeys[]) {
    const v = (values as any)[k]
    if (typeof v === 'boolean') rows.push({ key: KEYS[k], value: v ? 'true' : 'false' })
  }
  if (rows.length === 0) return
  const { error } = await supabase.from('app_settings').upsert(rows as any, { onConflict: 'key' })
  if (error) throw error
}

